import { localStorage, sessionStorage } from 'dibs-browser-storage';
import SV from 'server-vars';

import isPageType from '../../../utils/isPageType';
import { PAGE_TYPE } from '../../../utils/pageConstants';

import { SESSION_STORAGE_KEY, MODAL_IDS, EXPIRING_MODAL_IDS, VIEW_LIMIT } from './constants';

function hasSeenTradePromoThisSession() {
    if (sessionStorage) {
        return !!sessionStorage.getItem(SESSION_STORAGE_KEY);
    }
    return false;
}

export function canShowTradePromoModal() {
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    const isMobile = SV.get('settings.isMobile') || false;
    const isBlacklistedPage = isPageType([
        PAGE_TYPE.CHECKOUT,
        PAGE_TYPE.CHECKOUT_CONFIRMATION,
        PAGE_TYPE.ORDER_MANAGER,
        PAGE_TYPE.TRADE_REWARDS,
    ]);

    return isUserTypeTrade && !isMobile && !isBlacklistedPage && !hasSeenTradePromoThisSession();
}

export function isAtViewLimit(promo) {
    if (localStorage) {
        const modalStorage = localStorage.getItem(MODAL_IDS[promo]) || { totalViewCount: 0 };
        return modalStorage.totalViewCount >= VIEW_LIMIT;
    }
    return false;
}

export function markModalSeen(promo) {
    if (sessionStorage) {
        sessionStorage.setItem(SESSION_STORAGE_KEY, true);
    }
    if (localStorage && MODAL_IDS[promo]) {
        let modalStorage = localStorage.getItem(MODAL_IDS[promo]);
        if (modalStorage) {
            modalStorage.totalViewCount++;
        } else {
            modalStorage = {
                totalViewCount: 1,
            };
        }
        localStorage.setItem(MODAL_IDS[promo], modalStorage);
    }
}

export function markExpiringModalSeen(promo) {
    markModalSeen(promo);
    if (localStorage && EXPIRING_MODAL_IDS[promo]) {
        let modalStorage = localStorage.getItem(EXPIRING_MODAL_IDS[promo]);
        if (modalStorage) {
            modalStorage.totalViewCount++;
        } else {
            modalStorage = {
                totalViewCount: 1,
            };
        }
        localStorage.setItem(EXPIRING_MODAL_IDS[promo], modalStorage);
    }
}
